module.exports = __webpack_public_path__ + "static/media/11.Puppet Stand.743a3d56.JPG";